<script setup lang="ts">
import type { CategoryPage } from '~/types/database'

const props = defineProps<{
  category: CategoryPage
  productName?: string
}>()

const items = computed(() => {
  const breadcrumbs = [
    { label: 'Inicio', to: '/' },
    { label: props.category.name, to: `/${props.category.slug}` }
  ]

  if (props.productName) {
    breadcrumbs.push({
      label: props.productName,
      to: undefined as unknown as string
    })
  }

  return breadcrumbs
})
</script>

<template>
  <nav aria-label="Breadcrumb" class="text-sm">
    <ol class="flex items-center gap-2 flex-wrap">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-center gap-2"
      >
        <!-- Separator -->
        <UIcon
          v-if="index > 0"
          name="i-heroicons-chevron-right"
          class="w-4 h-4 text-gray-400 flex-shrink-0"
          aria-hidden="true"
        />

        <!-- Link or Text -->
        <NuxtLink
          v-if="item.to && index < items.length - 1"
          :to="item.to"
          class="text-gray-500 hover:text-primary-600 transition-colors"
        >
          {{ item.label }}
        </NuxtLink>
        <span
          v-else
          class="text-gray-900 font-medium truncate max-w-[200px] sm:max-w-none"
          :aria-current="index === items.length - 1 ? 'page' : undefined"
        >
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>
